/* 
  In theme.liquid vor </body> einbinden ODER
  direkt in kurs-produktseite.liquid ans Ende des <script> Blocks.
  
  Prüft ob das aktuelle Produkt bereits im Warenkorb ist
  und deaktiviert den "Jetzt buchen" Button entsprechend.
*/
(function() {
  document.addEventListener('DOMContentLoaded', function() {
    var btn = document.getElementById('mt-kurs-kaufen');
    if (!btn) return;

    /* Aktuelle Variant-ID aus dem Button-Context holen */
    /* (wird vom Liquid als data-attribute gesetzt – siehe unten) */
    var variantId = btn.getAttribute('data-variant-id');
    if (!variantId) return;

    /* Shopify Cart API abfragen */
    fetch('/cart.js')
      .then(function(r) { return r.json(); })
      .then(function(cart) {
        var alreadyIn = cart.items.some(function(item) {
          return String(item.variant_id) === String(variantId);
        });
        if (alreadyIn) {
          btn.disabled = true;
          btn.textContent = '✓ Bereits gebucht';
          btn.style.background = '#6B7A90';
          btn.style.cursor = 'not-allowed';
          btn.title = 'Dieser Kurs ist bereits in deinem Warenkorb';
        }
      });
  });
})();